import { api } from '../../../../../lib/api';
import { SCALE_SATISFACTION } from '../../../../../lib/utils/constants/FeedbackTypes';

export const createUserFeedback = ({ rate, campaignUuid, isAdmin = false }) => {
  return api({
    method: 'post',
    url: '/api/campaign_user_feedbacks',
    data: {
      campaign_user_feedback: {
        feedback_type: SCALE_SATISFACTION,
        feedback: rate,
        campaign_id: campaignUuid,
        reviewer_role: isAdmin ? 'admin' : 'regular_user',
      },
    },
  });
};

export const updateUserFeedback = ({ feedbackId, textRating }) => {
  return api({
    method: 'put',
    url: `/api/campaign_user_feedbacks/${feedbackId}`,
    data: {
      campaign_user_feedback: {
        feedback_message: textRating,
      },
    },
  });
};
